
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import AuthModal from '../../../components/feature/AuthModal';
import WechatModal from '../../../components/feature/WechatModal';

export default function ComplianceHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const [wechatOpen, setWechatOpen] = useState(false);

  const isActive = (path: string) => location.pathname === path;

  return (
    <>
      <header className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="max-w-[1400px] mx-auto px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-12">
            <div
              onClick={() => navigate('/')}
              className="flex items-center cursor-pointer"
            >
              <img
                src="https://static.readdy.ai/image/d6d1f2a32b22918380a2589cd9f5379c/24d32a4bc4a641f4b085ce8ca2481df2.png"
                alt="星贸云"
                className="h-[120px] w-auto object-contain"
              />
            </div>
            <nav className="flex items-center gap-8">
              {[
                { label: '首页', path: '/' },
                { label: '产品能力', path: '/capabilities' },
                { label: '场景方案', path: '/scenarios' },
                { label: '合规与治理', path: '/compliance' },
                { label: '关于我们', path: '/about' },
              ].map((item) => (
                <button
                  key={item.path}
                  onClick={() => navigate(item.path)}
                  className={`text-base transition-colors cursor-pointer whitespace-nowrap ${
                    isActive(item.path)
                      ? 'text-[#14B8A6] font-medium border-b-2 border-[#14B8A6] pb-0.5'
                      : 'text-gray-600 hover:text-[#14B8A6]'
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </nav>
          </div>
          <div className="flex items-center gap-3">
            <button
              onClick={() => setWechatOpen(true)}
              className="flex items-center gap-1.5 px-4 py-2 text-sm text-white bg-[#07C160] hover:bg-[#06AD56] rounded-full transition-all cursor-pointer whitespace-nowrap shadow-sm hover:shadow-md"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-wechat-line text-base leading-none"></i>
              </span>
              微信咨询
            </button>
            <button
              onClick={() => setAuthModalOpen(true)}
              className="px-5 py-2 text-sm text-gray-700 border border-gray-300 rounded-full hover:border-[#14B8A6] hover:text-[#14B8A6] transition-all cursor-pointer whitespace-nowrap"
            >
              登录 / 注册
            </button>
          </div>
        </div>
      </header>
      <AuthModal open={authModalOpen} onClose={() => setAuthModalOpen(false)} />
      <WechatModal isOpen={wechatOpen} onClose={() => setWechatOpen(false)} />
    </>
  );
}
